module.exports = __webpack_public_path__ + "static/media/icons-global-x-gray-clear-search.007d02ff.svg";